// Vendors
import React from 'react';
import { Facet } from '..';

const facets = [
  'pa_specials',
  'pa_fragrances',
  'pa_candle-size',
  'pa_product-type',
  'pa_product_cat'
];
const facetMap = new Map([
  ['pa_specials', 'Specials'],
  ['pa_fragrances', 'Fragrance Type'],
  ['pa_candle-size', 'Candle Size'],
  ['pa_product-type', 'Type'],
  ['pa_product_cat', 'Category']
]);

const FacetList = () =>
  facets.map((facet) => {
    const title = facetMap.get(facet);
    const attribute = facet;

    return (
      <Facet key={facet} id={facet} title={title} attribute_name={attribute} />
    );
  });

export default FacetList;
